import { defineMessages } from 'react-intl'

const scope = `modules.purchasing.features.editTermOrMethod.editableTermOrMethodTextField`

export default defineMessages({
  namePlaceholder: {
    id: `${scope}.namePlaceholder`,
    defaultMessage: 'Name',
  },
  nameAriaLabel: {
    id: `${scope}.nameAriaLabel`,
    defaultMessage: 'Name',
  },
  nameStatusIconIdleAriaLabel: {
    id: `${scope}.nameStatusIconIdleAriaLabel`,
    defaultMessage: 'Edit name',
  },
  nameStatusIconPendingAriaLabel: {
    id: `${scope}.nameStatusIconPendingAriaLabel`,
    defaultMessage: 'Saving name',
  },
  nameStatusIconResolvedAriaLabel: {
    id: `${scope}.nameStatusIconResolvedAriaLabel`,
    defaultMessage: 'Name saved',
  },
  nameStatusIconRejectedAriaLabel: {
    id: `${scope}.nameStatusIconRejectedAriaLabel`,
    defaultMessage: 'Failed to save name',
  },
  descriptionPlaceholder: {
    id: `${scope}.descriptionPlaceholder`,
    defaultMessage: 'Description',
  },
  descriptionAriaLabel: {
    id: `${scope}.descriptionAriaLabel`,
    defaultMessage: 'Description',
  },
  descriptionStatusIconIdleAriaLabel: {
    id: `${scope}.descriptionStatusIconIdleAriaLabel`,
    defaultMessage: 'Edit description',
  },
  descriptionStatusIconPendingAriaLabel: {
    id: `${scope}.descriptionStatusIconPendingAriaLabel`,
    defaultMessage: 'Saving description',
  },
  descriptionStatusIconResolvedAriaLabel: {
    id: `${scope}.descriptionStatusIconResolvedAriaLabel`,
    defaultMessage: 'Description saved',
  },
  descriptionStatusIconRejectedAriaLabel: {
    id: `${scope}.descriptionStatusIconRejectedAriaLabel`,
    defaultMessage: 'Failed to save description',
  },
})
